import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import DrawerMenu from "./components/DrawerMenu";
import Home from "./pages/Home";
import Estimate from "./pages/transactions/estimate/Estimate";
import AddEstimate from "./pages/transactions/estimate/AddEstimate";
import Enquiry from "./pages/transactions/enquiry/Enquiry";
import AddEnquiry from "./pages/transactions/enquiry/AddEnquiry";
import AddParts from "./pages/transactions/estimate/AddParts";
import ServiceOrder from "./pages/transactions/Service/ServiceOrder";
import AddServiceOrder from "./pages/transactions/Service/AddServiceOrder";
import MechanicHome from "./pages/Mechanic/MechanicHome";
import MechanicOrderUpdate from "./pages/Mechanic/MechanicOrderUpdate";
import EstimateBill from "./pages/transactions/estimate/EstimateBill";
import Invoice from "./pages/transactions/Invoice/Invoice";
import InvoiceGenaration from "./pages/transactions/Invoice/InvoiceGenaration";
import Customer from "./pages/MasterFiles/Customer/Customer";
import CustomerAddEdit from "./pages/MasterFiles/Customer/CustomerAddEdit";
import InvoiceBill from "./pages/transactions/Invoice/InvoiceBill";
import EstimateTask from "./pages/transactions/estimate/EstimateTask";
import Master from "./pages/MasterFiles/Master";
import ReportHome from "./pages/Reports/ReportHome";
import SettingsHome from "./pages/Settings/SettingsHome";
import Dashboard from "./pages/DashBoard/Dashboard";
import JobcardChart from "./pages/DashBoard/Chart/JobcardChart";
import CashJob from "./pages/transactions/Cashjob/CashJob";
import AddCashJob from "./pages/transactions/Cashjob/AddCashJob";
import Login from "./pages/Login";
import MechanicUpdate from "./pages/Mechanic/MechanicUpdate";
import Mechanic from "./pages/Mechanic/Mechanic";
import AddVehicle from "./pages/MasterFiles/VehicleMaster/AddVehicle";
import VehicleHome from "./pages/MasterFiles/VehicleMaster/VehicleHome";
// import MobileNavigation from "./components/MobileNavigation";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login/>} />
            <Route element={<DrawerMenu />}>
            {/* <Route path="/MobileNavigation" element={<MobileNavigation/>} /> */}
            <Route path="/home" element={<Home />} />
            <Route path="/estimate" element={<Estimate />} />
            <Route path="/add_estimate" element={<AddEstimate />} />
            <Route path="/estimate_task/:enquiryId" element={<EstimateTask />} />
            <Route path="/Estimate_Bill" element={<EstimateBill />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/add_enquiry" element={<AddEnquiry />} />
            <Route path="/service_Order" element={<ServiceOrder />} />
            <Route path="/add_service_order" element={<AddServiceOrder />} />
            <Route path="/add_parts" element={<AddParts />} />
            <Route path="/mechanic_home" element={<MechanicHome />} />
            <Route path="/mechanic_order_update" element={<MechanicOrderUpdate />}/>
            <Route path="/Invoice" element={<Invoice />} />
            <Route path="/Invoice_Genaration" element={<InvoiceGenaration />} />
            <Route path="/Invoice_Bill" element={<InvoiceBill />} />
            <Route path="/Cash_Job" element={<CashJob />} />
            <Route path="/Add_Cash_Job" element={<AddCashJob/>} />
            <Route path="/Customer" element={<Customer />} />
            <Route path="/Customer_Add_Edit" element={<CustomerAddEdit />} />
            <Route path="/Master" element={<Master/>} />
            <Route path="/Report" element={<ReportHome/>} />
            <Route path="/Settings" element={<SettingsHome/>} />
            <Route path="/Dashboard" element={<Dashboard/>} />
            <Route path="/Jobcard_Chart" element={<JobcardChart/>} />
            <Route path="/Vehicle" element={<VehicleHome/>} />
            <Route path="/Add_Vechicle" element={<AddVehicle/>} />
          </Route>
          <Route path="/mechanic" element={<Mechanic/>} />
          <Route path="/mechanic_update" element={<MechanicUpdate/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
